// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__1WS62","dark":"Preloader_dark__2cg9c","preloader-button":"Preloader_preloader-button___tCD2"};